<template>
    <div class="feedSearchResult">
        <search></search>
        <listItem></listItem>
    </div>
</template>
<script>
import search from "@/components/contents/babyFeeding/search";
import listItem from "@/components/contents/babyFeeding/recipes/listItem.vue";
export default {
    name:'feedSearchResult',
    data(){
        return{
        }
    },
    components:{
        search,
        listItem
    }
}
</script>